import {
  laravelGet,
  laravelPost,
  laravelPut,
  laravelPatch,
  laravelDelete,
} from '../utils/laravelClient';
import { ApiError } from '../utils/laravelError';

const AUTH = { auth: 'admin' };
const PUBLIC = { auth: 'none' };
const LOYALTY = { auth: 'loyalty', context: { redirectOnFailure: false } };

export const resetHookahCounter = (userId) =>
  laravelPost(`/loyalty-users/${userId}/reset-hookah`, null, AUTH);

export async function createPublicUser(data) {
  return laravelPost('/loyalty', data, AUTH);
}

export async function getPublicUsers(params = {}) {
  const query = { ...params };
  if (query.reservations_blocked) {
    query.reservations_blocked = 1;
  } else {
    delete query.reservations_blocked;
  }
  return laravelGet('/loyalty-users', { ...AUTH, params: query });
}

export async function getPublicUser(id) {
  return laravelGet(`/loyalty-users/${id}`, AUTH);
}

export async function incrementHookahCount(id, inc = 1, hookahTypeId = null) {
  const body = { inc };
  if (hookahTypeId) {
    body.hookah_type_id = hookahTypeId;
  }
  return laravelPost(`/loyalty-users/${id}/increment-hookah`, body, {
    ...AUTH,
    context: { operation: 'increment_hookah' },
  });
}

export async function deletePublicUser(id) {
  return laravelDelete(`/loyalty-users/${id}`, AUTH);
}

export async function updatePublicUser(id, data) {
  return laravelPut(`/loyalty-users/${id}`, data, AUTH);
}

export async function getHookahsCountByUUID(id) {
  return laravelGet(`/loyalty/${id}/hookahs-count`, PUBLIC);
}

export async function getHookahLogsWithCount(id) {
  try {
    return await laravelGet(`/loyalty/${id}/hookahs-count`, PUBLIC);
  } catch (error) {
    if (error instanceof ApiError && error.status === 404) {
      throw new Error(error.message || '404');
    }
    throw error;
  }
}

export async function getHookahsCountByToken(token) {
  return laravelGet(`/loyalty/token/${token}/hookahs-count`, PUBLIC);
}

export async function getUserByQrToken(token) {
  const tokenData = await laravelGet(`/loyalty/token/${token}/hookahs-count`, PUBLIC);

  if (tokenData?.id) {
    try {
      const userData = await laravelGet(`/loyalty/${tokenData.id}/hookahs-count`, PUBLIC);
      return { ...tokenData, ...userData };
    } catch (err) {
      console.error('Failed to fetch full user data:', err);
    }
  }

  return tokenData;
}

export async function recordLoyaltyConsent() {
  return laravelPost('/loyalty/consent', null, LOYALTY);
}

/** @deprecated Use recordLoyaltyConsent() — public consent by UUID was removed. */
export async function consentPublicUser() {
  return recordLoyaltyConsent();
}

export async function deleteLoyaltyAccount() {
  return laravelDelete('/loyalty/account', LOYALTY);
}

export async function updateLoyaltyProfile(data) {
  return laravelPut('/loyalty/profile', data, LOYALTY);
}
